import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Add as AddIcon,
  CalendarToday as CalendarIcon,
  People as PeopleIcon,
  LocationOn as LocationIcon,
  Description as DescriptionIcon,
} from "@material-ui/icons";
import "../styles/AddCampaign.scss";
import CustomSelect from "../../Shared/CustomSelect/CustomSelect";
import CustomDatePicker from "../../Shared/CustomDatePicker/CustomDatePicker";
import CustomTextareaAutosize from "../../Shared/CustomTextareaAutosize/CustomTextareaAutosize";
import CustomTextField from "../../Shared/CustomTextField/CustomTextField";
import teamOptions from "../helper/teamOptions";
import initConfig from "../config";
import AxiosClient from "../../../Network/AxiosClient";
import { dummyTargetServiceMapping } from "../helper/dataSkeleton";
import FileUploader from "./FileUploader";
import CustomCheckbox from "./CustomCheckbox";
import ReasonManager from "./ReasonManager";
import axios from "axios";
import PrimaryActionButton from "../../Shared/PrimaryActionButton/PrimaryActionButton";
import SecondaryActionButton from "../../Shared/SecondaryActionButton/SecondaryActionButton";
import { format } from "date-fns";
import Typography from "@material-ui/core/Typography";
import capitalizeFirstLetter from "../helper/capitalizeFisrtLetter";
import { use } from "react";

import { toast } from "react-toastify";

const AddCampaign = ({ onCampaignAdd }) => {
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    ...initConfig,
  });
  const [targetServiceMapping, setTargetServiceMapping] = useState(null);

  console.log("rerenders");

  useEffect(() => {
    if (!targetServiceMapping) fetchTargetServiceMapping();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      increment_amount_value: "",
      increment_count_value: "",
      increment_mau_value: "",
    });
    // eslint-disable-next-line
  }, [formData["target_service"]]);

  useEffect(() => {
    setFormData({
      ...formData,
      ref_claim_end_date: "",
      eligibility_count: "",
    });
    // eslint-disable-next-line
  }, [formData["increment_eligibility_timeline_type"]]);

  const handleClose = () => {
    setOpen(false);
    resetForm();
  };

  const handleOpen = () => setOpen(true);

  const resetForm = () => {
    setFormData({ ...initConfig });
  };

  const generateOptionsFromObject = (object) => {
    if (!object) return [];
    const options = [];
    Object.keys(object).map((key) => {
      options.push({ id: key, name: capitalizeFirstLetter(key) });
    });
    return options;
  };

  const generateOptionsFromArray = (array) => {
    if (!array) return [];
    const options = [];
    array.map((item) => {
      options.push({ id: item, name: capitalizeFirstLetter(item) });
    });
    return options;
  };

  const fetchTargetServiceMapping = async () => {
    try {
      const response = await AxiosClient.get(
        `${process.env.REACT_APP_API_URL}/api/referral_service/v1/target-service-mapping`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        },
      );

      setTargetServiceMapping(response.data);
    } catch (error) {
      setTargetServiceMapping(dummyTargetServiceMapping);
      console.error("Error fetching target service mapping:", error);
    }
  };

  const validateForm = () => {
    var isDisabled = false;
    const newErrors = {};
    const requiredFields = [
      "file",
      "email",
      "campaign_name",
      "start_date",
      "end_date",
      "target_service",
      "target_parameter",
      "successful_ref_bonus",
      "increment_eligibility_timeline_type",
      "rejection_reason",
    ];

    if (formData["increment_eligibility_timeline_type"] === "non_rolling") {
      requiredFields.push("ref_claim_end_date");
    } else if (formData["increment_eligibility_timeline_type"] === "rolling") {
      requiredFields.push("eligibility_count");
    }

    requiredFields.forEach((field) => {
      if (
        !formData[field] ||
        formData[field] === "" ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        isDisabled = true;
        return;
      }
    });

    return isDisabled;
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }
  };
  const handleInputChange = (e) => {
    // console.log(e);
    const { key, value } = e.target;
    if (!formData.hasOwnProperty(key)) {
      throw `Invalid form data key: ${key}`;
    }

    setFormData({
      ...formData,
      [key]: value,
      target_parameter:
        key === "target_service" ? [] : formData["target_parameter"],
    });
  };

  const generateFormData = () => {
    const postData = new FormData();
    Object.keys(formData).forEach((key) => {
      const value = formData[key];

      // Handle arrays by appending multiple entries with the same key
      if (Array.isArray(value)) {
        if (value.length === 0) {
          // For empty arrays, append an empty string to indicate the field exists
          postData.append(key, "");
        } else {
          // For non-empty arrays, append each item with the same key
          value.forEach((item) => {
            postData.append(key, item);
          });
        }
      } else if (value !== null && value !== undefined) {
        var modifiedValue = value;
        if (
          key === "start_date" ||
          key === "end_date" ||
          key === "ref_claim_end_date"
        ) {
          modifiedValue =
            value.length === 0 ? "" : format(new Date(value), "yyyy-MM-dd");
        }
        postData.append(key, modifiedValue);
      }
    });

    if (!formData["target_parameter"].includes("Amount"))
      postData.append("increment_amount_value", "");
    if (!formData["target_parameter"].includes("Count"))
      postData.append("increment_count_value", "");
    if (!formData["target_parameter"].includes("MAU"))
      postData.append("increment_mau_value", "");

    if (formData["increment_eligibility_timeline_type"] === "non_rolling")
      postData.delete("eligibility_count");
    else if (formData["increment_eligibility_timeline_type"] === "rolling")
      postData.delete("ref_claim_end_date");
    else if (
      formData["increment_eligibility_timeline_type"] === "mtd_achievement"
    ) {
      postData.delete("eligibility_count");
      postData.delete("ref_claim_end_date");
    }

    return postData;
  };

  const postNewCampaign = () => {
    const formBody = generateFormData();
    setLoading(true);
    setErrors({});

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/uploads/v1/upload-service-referral`,
        formBody,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        },
      )
      .then((res) => {
        setLoading(false);
        toast.success("Campaign created successfully");
        handleClose();
        onCampaignAdd();
      })
      .catch((err) => {
        setLoading(false);

        // Handle different error scenarios
        if (err.response) {
          // Server responded with an error status code
          const { status, data } = err.response;

          if (status === 400 && data.errors) {
            // Validation errors
            const fieldErrors = {};
            Object.entries(data.errors).forEach(([field, message]) => {
              fieldErrors[field] = message;
            });
            setErrors(fieldErrors);
            toast.error("Please fix the form errors");
          } else if (status === 401 || status === 403) {
            // Authentication/Authorization errors
            toast.error("You don't have permission to create campaigns");
            setTimeout(() => {
              // Redirect to login if session expired
              window.location.href = "/signin";
            }, 2000);
          } else if (status === 413) {
            // File too large
            toast.error("The uploaded file is too large");
          } else {
            // Other server errors
            const errorMessage = data.message || "Failed to create campaign";
            toast.error(errorMessage);
          }
        } else if (err.request) {
          // Request made but no response received (network error)
          toast.error(
            "Network error. Please check your connection and try again",
          );
        } else {
          // Error in setting up the request
          toast.error("An unexpected error occurred");
        }

        console.error("Campaign creation error:", err);
      });
  };

  return (
    <div className="add-campaign-container">
      <PrimaryActionButton title="Add New Campaign" onClick={handleOpen} />

      <Dialog
        open={open}
        onClose={() => {}}
        maxWidth="lg"
        fullWidth
        aria-labelledby="form-dialog-title"
      >
        <div className="content-container">
          <div className="content-column">
            <FileUploader
              onFileUpload={(file) => {
                // Only update the file field, preserving all other form data
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  file,
                }));
              }}
            />
            <CustomTextField
              value={formData["email"]}
              onChangeValue={handleInputChange}
              label="Email"
              fieldKey="email"
              placeholder={"Enter a registered email"}
              inputLabelShrink={true}
              style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              isRequired
            />
            <CustomTextField
              value={formData["campaign_name"]}
              onChangeValue={handleInputChange}
              label="Campaign Name"
              fieldKey="campaign_name"
              placeholder={"Enter campaign name"}
              inputLabelShrink={true}
              style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              isRequired
            />

            <CustomDatePicker
              item={{
                label: "Referral Campaign Start Date",
                key: "start_date",
                value: formData["start_date"],
                maxDate: formData["end_date"] || undefined,
              }}
              onChangeDate={handleInputChange}
              style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              isRequired
            />
            <CustomDatePicker
              item={{
                label: "Referral Campaign End Date",
                key: "end_date",
                value: formData["end_date"],
                minDate: formData["start_date"] || undefined,
              }}
              onChangeDate={handleInputChange}
              style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              isRequired
            />
            <CustomTextareaAutosize
              value={formData.campaign_description}
              onChangeValue={handleInputChange}
              label="Campaign Description"
              fieldKey="campaign_description"
              placeholder="Type campaign description here"
              minRows={4}
              maxRows={6}
              error={errors.campaign_description}
              style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
            />
          </div>
          <div className="content-column">
            <h2 className="section-title">Set Target Service Details</h2>
            <CustomSelect
              item={{
                label: "Select Target Service",
                key: "target_service",
                options: generateOptionsFromObject(targetServiceMapping || {}),
                value: formData["target_service"],
              }}
              handleChange={handleInputChange}
              isMultiSelect={false}
              style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              isRequired
            />
            <CustomSelect
              item={{
                label: "Select Target Parameters",
                key: "target_parameter",
                options: generateOptionsFromArray(
                  targetServiceMapping && formData["target_service"]
                    ? targetServiceMapping[formData["target_service"]] || []
                    : [],
                ),
                value: formData["target_parameter"],
              }}
              handleChange={handleInputChange}
              isMultiSelect={true}
              style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              isRequired
            />
            <CustomTextField
              value={formData["successful_ref_bonus"]}
              onChangeValue={handleInputChange}
              label="Successful Referral Bonus (in BDT)"
              fieldKey="successful_ref_bonus"
              placeholder={"Type Bonus amount for this campaign"}
              inputLabelShrink={true}
              style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              isRequired
            />
            <h2 className="section-title">
              Set Overall Eligibility Parameters
            </h2>
            {
              <CustomSelect
                item={{
                  label: "Increment Eligibility Timeline Type",
                  key: "increment_eligibility_timeline_type",
                  options: [
                    { id: "rolling", name: "Rolling" },
                    { id: "non_rolling", name: "Non-Rolling" },
                    { id: "mtd_achievement", name: "MTD Achievement" },
                  ],
                  value: formData["increment_eligibility_timeline_type"],
                }}
                handleChange={handleInputChange}
                isMultiSelect={false}
                style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
                isRequired
              />
            }
            {formData["increment_eligibility_timeline_type"] ===
              "non_rolling" && (
              <CustomDatePicker
                item={{
                  label: "Referral Claim End Date",
                  key: "ref_claim_end_date",
                  value: formData["ref_claim_end_date"],
                  minDate: formData["start_date"] || undefined, // Can't be before campaign start
                }}
                onChangeDate={handleInputChange}
                style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
                isRequired
              />
            )}
            {formData["increment_eligibility_timeline_type"] === "rolling" && (
              <CustomTextField
                value={formData["eligibility_count"]}
                onChangeValue={handleInputChange}
                label="Increment Eligibility Day Count"
                fieldKey="eligibility_count"
                placeholder={"Type count of days"}
                inputLabelShrink={true}
                style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              />
            )}

            <div className="checkbox-group">
              <CustomCheckbox
                label="Don’t show this referral if MTD target Service achievement is greater than 0 at the time of referral."
                fieldKey="will_target_val_check"
                checked={formData["will_target_val_check"]}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="content-column">
            <h2 className="section-title">Set Increment Targets</h2>
            {formData["target_parameter"].length === 0 && (
              <Typography
                variant="body2"
                color="textSecondary"
                className="no-target-parameter-message"
              >
                No target parameter added yet. Add some target parameter(s) for
                this campaign.
              </Typography>
            )}
            {formData["target_parameter"].includes("Amount") && (
              <CustomTextField
                value={formData["increment_amount_value"]}
                onChangeValue={handleInputChange}
                label="Increment Amount Value"
                fieldKey="increment_amount_value"
                placeholder={"Type amount value"}
                inputLabelShrink={true}
                style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              />
            )}
            {formData["target_parameter"].includes("Count") && (
              <CustomTextField
                value={formData["increment_count_value"]}
                onChangeValue={handleInputChange}
                label="Increment Count Value"
                fieldKey="increment_count_value"
                placeholder={"Type count value"}
                inputLabelShrink={true}
                style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              />
            )}
            {formData["target_parameter"].includes("MAU") && (
              <CustomTextField
                value={formData["increment_mau_value"]}
                onChangeValue={handleInputChange}
                label="Increment MAU Value"
                fieldKey="increment_mau_value"
                placeholder={"Type MAU value"}
                inputLabelShrink={true}
                style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
              />
            )}
            <div className="section-container">
              <div className="section-header">
                <h2 className="section-title">
                  Rejection Reasons For Dropdown
                </h2>
                {formData.rejection_reason?.length > 0 && (
                  <div className="reason-count-chip">
                    {formData.rejection_reason.length}
                  </div>
                )}
              </div>
              <ReasonManager
                reasons={formData.rejection_reason || []}
                onChange={(updatedReasons) => {
                  setFormData({
                    ...formData,
                    rejection_reason: updatedReasons,
                  });
                }}
              />
            </div>
          </div>
        </div>

        <DialogActions className="add-referral-dialog-actions">
          <SecondaryActionButton
            onClick={handleClose}
            title={"Cancel"}
            style={{ maxWidth: 300 }}
          />

          <PrimaryActionButton
            onClick={postNewCampaign}
            disabled={loading || validateForm()}
            title={"Create Campaign"}
            style={{ maxWidth: 300 }}
            loading={loading}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddCampaign;
